import React from "react"
import { FormattedMessage } from "react-intl"
import { Progress } from "@carrotfertility/carotene-core"
import { useGetMemberIdInfo } from "#/components/member-id/hooks/useGetMemberIdInfo"
import { MemberIdCard } from "#/components/member-id/MemberIdCard"
import { PartnerProvidersSection } from "#/components/member-id/PartnerProvidersSection"
import { PageLayout } from "#/features/global-ui/page-layout"
import { PageHeader } from "#/features/global-ui/page-header"
import { MemberIdError } from "#/pages/member-id/MemberIdError"
import { useNavAvailability } from "#/services/feature-availability/useNavAvailability"

export function ConsumerMemberIdPage(): JSX.Element {
  const { firstName, lastName, isUsa, memberId, effectiveDate, isError, isLoading, pharmacyInfo } = useGetMemberIdInfo()
  const hasProviderFinder = useNavAvailability().show.providerFinder

  return (
    <PageLayout header={<PageHeader pageTitle={<FormattedMessage defaultMessage="Member ID" />} />}>
      {isError ? (
        <MemberIdError />
      ) : isLoading ? (
        <Progress />
      ) : (
        <>
          <PartnerProvidersSection hasProviderFinder={hasProviderFinder} />
          <MemberIdCard
            firstName={firstName}
            lastName={lastName}
            isUsa={isUsa}
            memberId={memberId}
            effectiveDate={effectiveDate}
            isLoading={isLoading}
            isError={isError}
            partnerShouldAppearOnMemberCard={false}
            pharmacyInfo={pharmacyInfo}
          />
        </>
      )}
    </PageLayout>
  )
}
